import {combineReducers} from 'redux';
import popupReducer from './popupReducer';
import authReducer from './authReducer';
import dataTableReducer from './dataTableReducer';
import filterReducer from './filterReducer';
import menuReducer from './menuItemSlice';
import searchReducer from './searchReducer';
import menuHeaderReducer from './menuHeaderReducer';
import editTableReducer from "./editTableReducer";
import editTableFamilyGroupReducer from "./editTableFamilyGroupReducer";
import pageDirtyReducer from './pageDirtyReducer';
import searchCountReducer from './searchCountReducer';

export default combineReducers({
  auth: authReducer,
  menuItem: menuReducer,
  filterReducer: filterReducer,
  dataTableReducer: dataTableReducer,
  editTableReducer: editTableReducer,
  popupReducer: popupReducer,
  searchReducer: searchReducer,
  menuHeaderReducer:menuHeaderReducer,
  editTableFamilyGroupReducer :editTableFamilyGroupReducer,
  pageDirtyReducer:pageDirtyReducer,
  searchCountReducer:searchCountReducer
})
